import styles from "../../style.module.scss";
import DatePicker, {registerLocale} from "react-datepicker";
import {useEffect, useRef, useState} from "react";
import "../../datepicker.css";
import ru from "date-fns/locale/ru";
import {subDays} from "date-fns";
import useStore from "../../store/store";
import {hoursSelect} from "../../const/const";
import formatDate from "../../utils/format-date";
import formatHours from "../../utils/format-hours";
import CheckAvailable from "../check-available/check-available";
import OffHoursNotice from "../ui/off-hours-notice/off-hours-notice";
import {hasOffHoursSelection, normalizeWorkTime} from "../../utils/work-time";
import useAppVersion from "../../hooks/use-app-version";
import RentCalendar from "../calendar/rent-calendar";
import {fetchCarPricesResponse, formatPeriodSaleDays} from "../../utils/calendar";

registerLocale("ru", ru);

function addDays(date, days) {
    var result = new Date(date);
    result.setDate(result.getDate() + days);
    return result;
}

const formatDayName = (dayName, lang) => {
    if (lang === 'en') {
        const dayMapping = {
            'monday': 'Mon',
            'tuesday': 'Tue',
            'wednesday': 'Wed',
            'thursday': 'Thu',
            'friday': 'Fri',
            'saturday': 'Sat',
            'sunday': 'Sun'
        };
        return dayMapping[dayName.toLowerCase()] || dayName;
    } else {
        const dayMapping = {
            'понедельник': 'Пн',
            'вторник': 'Вт',
            'среда': 'Ср',
            'четверг': 'Чт',
            'пятница': 'Пт',
            'суббота': 'Сб',
            'воскресенье': 'Вс'
        };
        return dayMapping[dayName.toLowerCase()] || dayName;
    }
};

function Step1({number, minRentDays, crmCarId}) {
    const datePickerRef = useRef();
    const [isMobile, setIsMobile] = useState(false);
    const [isCalendarOpen, setIsCalendarOpen] = useState(false);
    const {is: isVersion} = useAppVersion();
    const isV2 = isVersion(2);
    const currentDate = useStore((state) => state.currentDate)
    const startDate = useStore((state) => state.startDate)
    const setStartDate = useStore((state) => state.setStartDate)
    const startHours = useStore((state) => state.startHours)
    const setStartHours = useStore((state) => state.setStartHours)
    const finishDate = useStore((state) => state.finishDate)
    const setFinishDate = useStore((state) => state.setFinishDate)
    const finishHours = useStore((state) => state.finishHours)
    const setFinishHours = useStore((state) => state.setFinishHours)
    const promoHtml = useStore((state) => state.promoHtml)
    const lang = useStore((state) => state.lang)
    const workTime = useStore((state) => state.workTime)
    const carId = useStore((state) => state.carId)
    const periodSales = useStore((state) => state.periodSales)
    const setPeriodSales = useStore((state) => state.setPeriodSales)

    const normalizedWorkTime = normalizeWorkTime(workTime);
    const showOffHoursNotice = hasOffHoursSelection(startHours, finishHours, normalizedWorkTime);

    const t = {
        specifyPeriod: lang === 'en' ? 'Specify the period' : 'Укажите период',
        startDate: lang === 'en' ? 'Start date' : 'Дата начала',
        startTime: lang === 'en' ? 'Start time' : 'Время начала',
        returnDate: lang === 'en' ? 'Return date' : 'Дата возврата',
        returnTime: lang === 'en' ? 'Return time' : 'Время возврата',
        finishTime: lang === 'en' ? 'Finish time' : 'Время возврата',
        apply: lang === 'en' ? 'Apply' : 'Применить',
        discount: lang === 'en' ? 'Discount' : 'Скидка',
    };

    const sliceHoursCount = !!startDate?.getDate() && !!currentDate?.getDate() && startDate.getDate() === currentDate.getDate() ? parseInt(currentDate.getHours()) : 0;


    const onChangeDatepicker = (dates) => {
        const [start, finish] = dates;

        // Проверяем минимальное количество дней
        if (start && finish) {
            const diffTime = Math.abs(finish - start);
            const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

            if (diffDays < minRentDays) {
                // Если выбрано меньше дней чем minRentDays, устанавливаем дату окончания автоматически
                const newFinishDate = addDays(start, minRentDays);
                setStartDate(start);
                setFinishDate(newFinishDate);
                return;
            }
        }

        setStartDate(start);
        setFinishDate(finish);
        /*const [start, finish] = dates;

        setStartDate(start);
        setFinishDate(finish);*/
    };

    const onChangeHoursSelect = (e) => {

        if (e.target.name === 'startHours') {
            setStartHours(parseInt(e.target.value));
        }
        if (e.target.name === 'finishHours') {
            setFinishHours(parseInt(e.target.value));
        }
    }
    const handleCLoseClick = () => {
        if (!startHours) {
            setStartHours(sliceHoursCount)
        }
        if (!finishHours) {
            setFinishHours(0)
        }

        datePickerRef.current.setOpen(false);
    }
    useEffect(() => {
        let now = new Date();
        now.setHours(now.getHours() + 3);
        let def = false;
        if (startDate === null || startHours === null) {
            let b_date_start = !!localStorage.getItem('b_date_start') ? localStorage.getItem('b_date_start').split('-') : null;
            let b_time_start = !!localStorage.getItem('b_time_start') ? localStorage.getItem('b_time_start').split(':') : null;
            if (!!b_date_start && !!b_time_start) {
                const newStartDate = new Date(b_date_start[2], b_date_start[1] - 1, b_date_start[0], b_time_start[0], b_time_start[1], 0);
                const newStartHours = b_time_start[0];
                if (newStartDate > now) {
                    setStartDate(newStartDate);
                    setStartHours(parseInt(newStartHours));
                } else {
                    setStartDate(now);
                    setStartHours(parseInt(now.getHours()));
                    def = true;
                }
            } else {
                setStartDate(now);
                setStartHours(parseInt(now.getHours()));
                def = true;
            }
        }
        if (finishDate === null || finishHours === null) {
            let b_date_finish = !!localStorage.getItem('b_date_finish') ? localStorage.getItem('b_date_finish').split('-') : null;
            let b_time_finish = !!localStorage.getItem('b_time_finish') ? localStorage.getItem('b_time_finish').split(':') : null;
            if (!!b_date_finish && !!b_time_finish) {
                const newFinishDate = new Date(b_date_finish[2], b_date_finish[1] - 1, b_date_finish[0], b_time_finish[0], b_time_finish[1], 0);
                const newFinishHours = b_time_finish[0];
                if (newFinishDate > now && !def) {
                    setFinishDate(newFinishDate);
                    setFinishHours(parseInt(newFinishHours));
                } else {
                    const minFinishDate = addDays(now, minRentDays);
                    setFinishDate(minFinishDate);
                    setFinishHours(parseInt(minFinishDate.getHours()));
                }
            } else {
                const minFinishDate = addDays(now, minRentDays);
                setFinishDate(minFinishDate);
                setFinishHours(parseInt(minFinishDate.getHours()));
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [minRentDays]);
    useEffect(() => {
        if (window.innerWidth <= 991) {
            setIsMobile(true);
        }
    }, []);
    useEffect(() => {
        if (!!startDate?.getDate() && sliceHoursCount > 0 && sliceHoursCount > startHours) {
            setStartHours(sliceHoursCount)
        }
    }, [startDate, sliceHoursCount, startHours, setStartHours]);

    useEffect(() => {
        if (!isV2 || (!carId && !crmCarId)) {
            if (!isV2) {
                setPeriodSales(null);
            }
            return undefined;
        }

        const ac = new AbortController();
        const from = startDate || new Date();
        const to = finishDate || addDays(from, 60);

        fetchCarPricesResponse({
            id: carId,
            carid: crmCarId,
            dtstart: formatDate(from),
            dtend: formatDate(to),
            signal: ac.signal,
        })
            .then((data) => {
                if (!ac.signal.aborted) {
                    setPeriodSales(data?.periodSales || null);
                }
            })
            .catch((error) => {
                if (error?.name === 'AbortError') {
                    return;
                }
                console.error(error.message);
                if (!ac.signal.aborted) {
                    setPeriodSales(null);
                }
            });

        return () => {
            ac.abort();
        };
        // periodSales — метаданные авто, не зависят от выбранных дат
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isV2, carId, crmCarId, setPeriodSales]);

    return (<div className={styles.newOrder__step}>
        <div className={`${styles.newOrder__stepHead} p-size`}>
            <div className={styles.newOrder__stepNumber}>
                {number}
            </div>
            {t.specifyPeriod}
            <div dangerouslySetInnerHTML={{__html: promoHtml}}/>
        </div>
        <div className={styles.newOrder__stepContent}>

            <input type="text" id={'userDateStart'} className={styles.dateInput} placeholder={t.startDate}
                   value={formatDate(startDate)}
                   disabled/>
            <input type="text" className={styles.timeInput} placeholder={t.startTime}
                   value={formatHours(startHours)}
                   disabled/>
            <input type="text" className={styles.dateInput} placeholder={t.returnDate}
                   value={formatDate(finishDate)}
                   disabled/>
            <input type="text" className={styles.timeInput} placeholder={t.returnTime}
                   value={formatHours(finishHours)}
                   disabled/>
            {isV2 ? (
                <>
                    <button type="button" className={styles.calendar} onClick={() => setIsCalendarOpen(true)}/>
                    <RentCalendar
                        open={isCalendarOpen}
                        onClose={() => setIsCalendarOpen(false)}
                        minRentDays={minRentDays}
                        crmCarId={crmCarId}
                    />
                </>
            ) : (
                <DatePicker
                    ref={datePickerRef}
                    className={styles.calendar}
                    closeOnScroll={!isMobile}
                    onChange={onChangeDatepicker}
                    monthsShown={2}
                    startDate={startDate}
                    endDate={finishDate}
                    locale={lang}
                    selectsRange
                    minDate={subDays(currentDate, 0)}
                    maxDate={startDate ? addDays(startDate, 365) : null}
                    withPortal
                    formatWeekDay={(dayName) => formatDayName(dayName, lang)}
                    shouldCloseOnSelect={false}
                    onCalendarOpen={() => {
                        document.activeElement.blur();
                    }}
                >
                    <div className={styles.datePickerFooter}>
                        <div className={styles.col}>
                            {t.startTime}
                            <select name={`startHours`} onChange={onChangeHoursSelect}
                                    value={startHours !== null ? startHours : ''}>
                                {hoursSelect.slice(sliceHoursCount).map((item, index) => <option key={index}
                                                                                                 value={parseInt(item.replace(':00', ''))}>{item}</option>)}
                            </select>
                        </div>
                        <div className={styles.col}>
                            {t.finishTime}
                            <select name={`finishHours`} onChange={onChangeHoursSelect}
                                    value={finishHours !== null ? finishHours : ''}>
                                {hoursSelect.map((item, index) => <option key={index}
                                                                          value={parseInt(item.replace(':00', ''))}>{item}</option>)}
                            </select>
                        </div>
                        <button className={styles.button} onClick={() => handleCLoseClick()}>
                            {t.apply}
                        </button>
                    </div>

                </DatePicker>
            )}

            {isV2 && periodSales?.length > 0 && (
                <div className={styles.periodSales}>
                    {periodSales.map((item) => (
                        <div key={`${item.days}-${item.percent}`} className={styles.periodSaleCard}>
                            <div className={styles.periodSaleTitle}>{t.discount} {item.percent}%</div>
                            <div className={styles.periodSaleDesc}>
                                {formatPeriodSaleDays(item.days, lang)}
                            </div>
                        </div>
                    ))}
                </div>
            )}

            {showOffHoursNotice && (
                <OffHoursNotice workTime={normalizedWorkTime} lang={lang}/>
            )}

        </div>
        <CheckAvailable/>
    </div>)
}

export default Step1;

